import request from '@/utils/request';

export default {
  getList: data => request.get('/heyhey/gift', { params: data }),
  update: data => request.post('/heyhey/gift', data),
  detail: id => request.get(`/heyhey/gift/${id}`)
};
